import store from '@/store'
import { find } from 'lodash'
import { accessDeniedToaster } from '../pop-denied-access'

let guard = () => new Promise((resolve, reject) => {
  return (
    find(store.getters['auth/abilities'], ability =>
      ability.name === 'view-asset-transfers-report' &&
      ability.entity_type === 'Billow\\Models\\Asset'
    )
  ) ? resolve() : accessDeniedToaster(reject, {
    name: 'asset-admin-index'
  })
})

export default {
  name: 'view-asset-transfers-report',
  run: guard
}